"use strict";

import dispatcher from "./../dispatcher";
import {Singleton} from "vwa/flux";

const focusedVehicleStore = new Singleton();
export default focusedVehicleStore;

window.focusedVehicleStore = focusedVehicleStore;

dispatcher.on('focusVehicle', vehicleId =>
	focusedVehicleStore.set(vehicleId || null)
);


// WEBPACK FOOTER //
// ./src/store/focusedVehicle.js